<template>
  <div class="header header-comp">
    <nav class="navbar navbar-default" style="border: none;">
      <div class="container-fluid">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand" href="#"><img :src="webConfigInfo.companyLogoAttachmentUrl" alt="" :width="webConfigInfo.companyLogoWidth" :height="webConfigInfo.companyLogoHeight" @click='jump(webConfigInfo.websiteUrl)'></a>
        </div>
        <!-- Collect the nav links, forms, and other content for toggling -->
        <transition name="el-fade-in-linear">
        <div class="navbar-collapse hidden-xs" id="bs-example-navbar-collapse-1"  v-show="!searchShow">
          <ul class="nav navbar-nav" style="margin-left: 0">
            <!--判断供应商-->
            <!--<li class="active"><a href="#">Link <span class="sr-only">(current)</span></a></li>-->
            <li v-for="(item,index) in navigationColumnInfos" :key="index" class="dropdown">
              <i class="icon-new" v-if="item.columnName ==='福星购'"></i>
              <a :class="item.columnAccessPath.indexOf('supplier') == -1?item.columnAccessPath.substring(1):item.columnAccessPath.substr(1,8)"
                 v-if="item.columnName!=='产品与服务介绍'&&
                       item.columnName!=='供应商资源大厅'&&
                       item.columnName!=='招标公告'&&
                       item.columnName!=='商机查询'&&
                       item.columnName!=='企业电商'"
                 @click='jump(item.columnAccessPath, item)'>{{item.columnName}}</a>
              <a :class="item.columnAccessPath.indexOf('supplier') == -1?item.columnAccessPath.substring(1):item.columnAccessPath.substr(1,8)"
                 v-if="item.columnName==='供应商资源大厅'"
                 :href="item.columnAccessPath"
                 @click="sensorsTabClick(item.columnName)" target="_blank" >{{item.columnName}}</a>

              <a :class="item.columnAccessPath.indexOf('supplier') == -1?item.columnAccessPath.substring(1):item.columnAccessPath.substr(1,8)"
                 v-if="item.columnName==='招标公告'||item.columnName==='商机查询'" :href="leadSteps.maskStep?item.columnAccessPath:'javascript:;'"  @click="sensorsTabClick(item.columnName)">
                <transition name="el-fade-in">
                  <div class="purchaserLeadStep" v-show="leadSteps.secondStep">
                    <p>点击【{{item.columnName}}】查看采购方商机，搜索适合您的招投标和询报价项目</p>
                    <el-button @click.stop.prevent="stepLogged('secondStep','thirdStep')">下一步</el-button>
                    <div class="leadArrowDown">
                      <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/leadArrowDown.png" alt="">
                    </div>
                  </div>
                </transition>
                <span :class="leadSteps.secondStep?'navLead':''">{{item.columnName}}</span>
              </a>

              <a :class="item.columnAccessPath.indexOf('supplier') == -1?item.columnAccessPath.substring(1):item.columnAccessPath.substr(1,8)"
                 v-if="item.columnName==='企业电商'"
                 :href="item.columnAccessPath"
                 target="_blank">{{item.columnName}}</a>


              <a id="proAndSolutPage"
                  v-if="item.columnName==='产品与服务介绍'" @click="sensorsTabClick(item.columnName)" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                {{item.columnName}}
              </a>

              <ul v-if="item.columnName==='产品与服务介绍'" class="dropdown-menu">
                <li v-for="(child,childIndex) in item.children" :key="childIndex" @click="sensorsTabClick(child.columnName)">
                  <a v-if="child.columnName !== '企业电商'" @click='jumpExt(child.columnAccessPath)'>{{child.columnName}}</a>
                  <a v-if="child.columnName === '企业电商'" :href="child.columnAccessPath" target="_blank">{{child.columnName}}</a>
                </li>
              </ul>
            </li>
          </ul>
          <ul class="nav navbar-nav pull-right" style="margin-left: 0">
            <li class="search">
              <a style="padding-left: 15px;padding-right: 15px;" @click.stop.prevent="searchShow=true"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/search_icon.png" alt=""></a>
            </li>
            <li v-if="currentLogin" class="custom-theme-bg-blue-btn">
              <a class="pull-right" href="javascript:void(0);" @click="jumpWorkBench">我的工作台</a>
            </li>
<!--            <li v-else class="nav-right-wrap">-->
<!--              <a class="pull-right custom-theme-bg-blue-btn" @click="jump('/loginEn')">Login</a>-->
<!--              <a class="pull-right" @click="jump('/register')">免费注册</a>-->
<!--              <a class="pull-right custom-theme-bg-blue-btn" @click="jump('/login')">立即登录</a>-->
<!--            </li>-->

          </ul>
        </div>
        </transition>
        <transition name="el-fade-in-linear">
        <div class="searchNav" v-show="searchShow"  @click.stop="searchShow=true">
            <el-input :placeholder="headSearchText" v-model="keyword" class="input-with-select" @keyup.enter.native="search()">
            <el-button slot="prepend"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/search_icon.png" alt=""></el-button>
            <el-button slot="append"  type="text" @click.stop="searchShow=false">取消</el-button>
          </el-input>
          <div class="optionBox">
            <el-button type="text" class="oneBtn active" @click="optionSelect(1,'供应商、产品、服务')">供应商名称、产品、服务类别</el-button>
            <!--<el-button type="text" class="twoBtn" @click="optionSelect(2,'产品、服务')">产品、服务类别</el-button>-->
            <el-button type="text" class="threeBtn" @click="optionSelect(3,'集采协议')">集采协议</el-button>
            <el-button type="text" class="fourBtn" @click="optionSelect(4,'招标公告')">招标公告</el-button>
            <!--<el-button type="text" class="fiveBtn" @click="optionSelect(5,'询报价公告')">询报价公告</el-button>-->
            <!--<el-button type="text" class="sixBtn" @click="optionSelect(6,'中标公示')">中标公示</el-button>-->
          </div>
        </div>
        </transition>
      </div>
    </nav>
    <v-fuXingPurchaseDialog ref="fuXingPurchaseDialog"></v-fuXingPurchaseDialog>
  </div>
</template>
<script>
  import { mapState, mapMutations } from 'vuex'
  import fuXingPurchaseDialog from '@/components/fuXingPurchaseDialog'
  import {customTabClick} from '@/assets/js/sensors'
  export default {
  props: ['navigationColumnInfos','webConfigInfo','hitSearchUrl','enterpriseResourceBaseUrl'],
  components: {
    'v-fuXingPurchaseDialog': fuXingPurchaseDialog
  },
  data () {
    return{
      searchShow:false,
      keyword:'',
      selectType:'1',
      supplierManagerUrl:'',
      recruitPurchaserUrl:'',
      recruitSupplierUrl:'',
      coordinationManagerUrl:'',
      coordinationSupplierUrl:'',
      currentLogin:'',
      headSearchText:'请输入供应商、产品、服务关键词查询'
    }
  },
  created () {
    this.currentLogin = this.getToken('isLogin');
    if(this.currentLogin !=''){
      this.userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
    }
  },
  mounted(){
    Object.assign(this, mapMutations(['modifyLeadStep']));
    this.isLogin()
  },
  computed: mapState([
    'KP',
    'leadSteps'
  ]),
  updated(){
    this.dropMenu();
    this.currentPage();
  },
  methods: {
    async jumpWorkBench (url) {
      await this.$store.dispatch('findWebDtoHandler');
      this.$store.dispatch('informationCompletion', () => {
        this.$router.push('workBench')
      });
    },

    jump(url, item){
        if (item) {
          try {
            this.sensorsTabClick(item.columnName)
          } catch (e) {console.log(e)}
        }

        if (item && item.columnName === "福星购") {
          this.$refs.fuXingPurchaseDialog.dialogVisible = true
        } else if(url.indexOf('http') == 0){
          window.location.href = url;
        } else{
          if(url.indexOf('supplier') != -1){
  //          this.$router.push({path:url,query:{searchKeyWord:this.KeyWord,bussiessType:2}});
            this.$router.push({path:url,query:{bussiessType:2}});
            this.$emit('navChangeBussinessType',2)
            $('#supplierEntryTab a[href="'+'#tenderNnotice'+'"]').tab('show');
            this.$emit('pagePosition');
          }else{
             this.$router.push({path:url});
          }
        }


    },
    // 埋点
    sensorsTabClick (name) {
      customTabClick({
        position: "首页",
        tab_name: name
      })
    },
    jumpExt(url){
      /*
      * 1. 未登录状态下 跳转
      * 2. 账号异常状态
      * 3. 登录状态下 跳转
      * */
      if(this.getToken('isLogin') == ''){
        if(url.indexOf('http') == 0){
          window.location.href = url;
        }else{
          this.$router.push({path:url});
        }
      }else if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:url});
        // this.$router.push({path:"registerExamine",query:{email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName}});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
      }
      else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId"))== "1"){
        this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
      }else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
        this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
          cancelButtonClass:'cancelBtn',
          customClass:'mobileText',
          cancelButtonText: '以后再说',
          confirmButtonText: '点我补全',
          center: true
        }).then(() => {
          this.$router.push({path:'/inforPerfection'});
        }).catch(() => {
            this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
            }).then((res) => {
              this.data = res.data;
              this.removeCookie('TALK_LATER_'+this.data.userId);
              this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
            });
        });
      } else{
        if(url.indexOf('http') == 0){
          window.location.href = url;
        }else{
          this.$router.push({path:url});
        }
      }
    },
    optionSelect(val,placeValue){
      this.headSearchText = "请输入"+placeValue+"关键词查询"
      if(val==1){
        $('.oneBtn').addClass('active');
        $('.twoBtn').removeClass('active');
        $('.threeBtn').removeClass('active');
        $('.fourBtn').removeClass('active');
        $('.fiveBtn').removeClass('active');
        $('.sixBtn').removeClass('active');
        this.selectType = val;
      }
      if(val==2){
        $('.oneBtn').removeClass('active');
        $('.twoBtn').addClass('active');
        $('.threeBtn').removeClass('active');
        $('.fourBtn').removeClass('active');
        $('.fiveBtn').removeClass('active');
        $('.sixBtn').removeClass('active');
        this.selectType = val;
      }
      if(val==3){
        $('.oneBtn').removeClass('active');
        $('.twoBtn').removeClass('active');
        $('.threeBtn').addClass('active');
        $('.fourBtn').removeClass('active');
        $('.fiveBtn').removeClass('active');
        $('.sixBtn').removeClass('active');
        this.selectType = val;
      }
      if(val==4){
        $('.oneBtn').removeClass('active');
        $('.twoBtn').removeClass('active');
        $('.threeBtn').removeClass('active');
        $('.fourBtn').addClass('active');
        $('.fiveBtn').removeClass('active');
        $('.sixBtn').removeClass('active');
        this.selectType = val;
      }
      if(val==5){
        $('.oneBtn').removeClass('active');
        $('.twoBtn').removeClass('active');
        $('.threeBtn').removeClass('active');
        $('.fourBtn').removeClass('active');
        $('.fiveBtn').addClass('active');
        $('.sixBtn').removeClass('active');
        this.selectType = val;
      }
      if(val==6){
        $('.oneBtn').removeClass('active');
        $('.twoBtn').removeClass('active');
        $('.threeBtn').removeClass('active');
        $('.fourBtn').removeClass('active');
        $('.fiveBtn').removeClass('active');
        $('.sixBtn').addClass('active');
        this.selectType = val;
      }
    },
    search(){
      if(this.selectType == '1'){
        window.location.href = this.hitSearchUrl + this.keyword;
      }
      if(this.selectType == '2'){
        window.location.href = this.hitSearchUrl + this.keyword;
      }
      if(this.selectType == '3'){
        if(this.$route.path=="/protocol"){
          this.$emit('selectKeyword',this.keyword)
        }else{
          this.$router.push({path:'/protocol',query:{searchKeyWord:this.keyword}})
        }
      }
      if(this.selectType == '4'){
        if(this.$route.path=="/supplier"){
          this.$emit('navSearchContent',{bussiessType:2,keyword:this.keyword})
        }else{
          this.$router.push({path:'/supplier',query:{searchKeyWord:this.keyword,bussiessType:2}})
        }
        this.$emit('pagePosition');
      }
      if(this.selectType == '5'){
        if(this.$route.path=="/supplier"){
          this.$emit('navSearchContent',{bussiessType:1,keyword:this.keyword})
        }else{
          this.$router.push({path:'/supplier',query:{searchKeyWord:this.keyword,bussiessType:1}})
        }
        this.$emit('pagePosition');
      }
      if(this.selectType == '6'){
        if(this.$route.path=="/supplier"){
          this.$emit('navSearchContent',{bussiessType:3,keyword:this.keyword})
        }else{
          this.$router.push({path:'/supplier',query:{searchKeyWord:this.keyword,bussiessType:3}})
        }
        this.$emit('pagePosition');
      }
    },
    dropMenu(){
      $('.dropdown-toggle').parent('.dropdown').mouseover(function () {
        $(this).children('.dropdown-toggle').eq(0).siblings('.dropdown-menu').show()
//        $(this).children('.dropdown-toggle').eq(0).dropdown('toggle')
      });
      $('.dropdown-toggle').parent('.dropdown').mouseleave(function () {
//        $(this).children('.dropdown-toggle').eq(0).dropdown('toggle')
        $(this).children('.dropdown-toggle').eq(0).siblings('.dropdown-menu').hide()
      });

      $("html, body").click((e)=>{
        this.searchShow = false;
      });
    },
//    页面定位
//      pagePosition(){
//        $("html, body").animate({
//          scrollTop: $("#supplierEntry").offset().top }, {duration: 500,easing: "swing"});
//    },
    currentPage(){
      let className = this.$route.name
      if(this.$route.name == 'purchaser'){
        $('#purchaserPage').addClass('active')
//        if(this.getToken('userTag') == ''){
//          $('#purchaserPage').removeClass('active')
//        }
      }else if(this.$route.name == 'supplier'){
//        if(this.$route.fullPath == "/supplier"){
          if(this.$route.query.shortcutMenu){
            $('#supplierPage').addClass('active')
            $('.'+className).eq(0).removeClass('active')
            $('#purchaserPage').removeClass('active')
          }else{
            $('.'+className).eq(0).addClass('active')
            $('#supplierPage').removeClass('active')
            $('#purchaserPage').removeClass('active')
          }

//          if(this.getToken('userTag') == ''){
//            $('#supplierPage').removeClass('active')
//          }
//        }
//        else{
//          $('#supplierPage').addClass('active')
//          $('.'+className).eq(0).removeClass('active')
//        }
      }else if(this.$route.name == 'recruitmentSystem' || this.$route.name == 'supplyChain' || this.$route.name == 'supplierManagement'){
        $('.dropdown').children('.'+className).eq(0).addClass('active')
        $('#proAndSolutPage').addClass('active')
      }else{
        $('.'+className).eq(0).addClass('active')
      }
    },
    //    判断是否从登陆页跳转过来
    isLogin(){
      if(this.$route.query.shortcutMenu){
        this.homePage();
      }
    },
//    是否是网站首页判断
    homePage(){
      if(this.$route.path == '/'){
        return
      }else{
        this.logOnAsActive();
      }
    },
    //    判断是否登录及登录身份 10供应商  20采购商
    logOnAsActive(){
      if(this.getToken('isLogin') == 100){
        let userTag = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));;
        if(userTag.userTag == '10'){
          $('#supplierPage').addClass('active')
        }else if(userTag.userTag == '20'){
          $('#purchaserPage').addClass('active')
        }
      }
    },
    stepLogged(val1,val2){
      this['modifyLeadStep']({
        [val1]: false,
        [val2]:true
      })
    }
  }
}
</script>
<style lang="stylus">
  .header-comp{
    .custom-theme-bg-blue-btn {
      background-color: #3f88e0 !important;
      a{
        color: #fff !important;
      }
    }
    .nav-right-wrap{
      a{
        padding-left: 15px !important;
        padding-right: 15px !important;
      }
      .custom-theme-bg-blue-btn{
        color: #fff !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/v-header/header.vue